import ButtonArrow from "../assets/icons/button-arrow.svg";
import Loader from "../assets/icons/loader.png";

const Button = ({
  text = "",
  className,
  handleClick,
  icon,
  loading,
  showIcon = false,
}) => {
  return (
    <button
      type="button"
      onClick={handleClick}
      className={`btn normal-button ${className || ""}`}
    >
      <span>
        {loading && <img className="loader" src={Loader} alt="loader" />}
        {text}
      </span>
      {showIcon && (
        <div>
          <img src={icon ? icon : ButtonArrow} />
        </div>
      )}
    </button>
  );
};

const DarkButton = ({
  text = "",
  className,
  showIcon = false,
  handleClick,
  loading,
}) => {
  return (
    <button
      type="button"
      className={`btn dark-button ${className || ""}`}
      onClick={handleClick}
    >
      <span>
        {loading && <img className="loader" src={Loader} alt="loader" />}
        {text}
      </span>
      {showIcon && (
        <div>
          <img src={ButtonArrow} />
        </div>
      )}
    </button>
  );
};

export default Button;
export { DarkButton };
